import { PAGES, GUEST_REGEX, PASS_STATUS } from '../util/constants'
import _ from 'moment'
export function drawerIsOpen(state) {
  return state.uiControl.drawer.open;
}
export function getPageTitle(state) {
  const path = state.router.location.pathname;
  const page = Object.keys(PAGES).find((page) => {
    const pattern = PAGES[page].pattern;
    return path.match(pattern);
  });
  if (page) {
    return PAGES[page].title
  } else {
    return "";
  }
}
export function isTimestamp(blob) {
  return !!Date.parse(blob);
}
/**
 * 
 * @param {Blob[]} arr 
 * @param {string} attribute 
 * @returns {Blob[]}
 */
export function sortLowToHighByAttribute(arr, attribute) {

  function sortLowToHighByIntAttribute(array, attribute) {
    const sorted = array.sort((a, b) => {
      return a[attribute] > b[attribute];
    });
    return [...sorted];
  }
  function sortLowToHighByTimestampAttribute(array, attribute) {
    const sorted = array.sort((a, b) => {
      return Date.parse(a[attribute]) > Date.parse(b[attribute]);
    });
    return [...sorted];
  }
  if (arr.length === 0) return [];
  if (typeof arr[0][attribute] === "number") return sortLowToHighByIntAttribute(arr, attribute);
  if (isTimestamp(arr[0][attribute])) return sortLowToHighByTimestampAttribute(arr, attribute);
  const intArray = arr.map((el) => {
    return { ...el, [attribute]: parseInt(el[attribute], 10) };
  });
  return sortLowToHighByIntAttribute(intArray, attribute).map((intEl) => {
    return { ...intEl, [attribute]: `${intEl[attribute]}` };
  });
}
/**
 * 
 * @param {{created:string}} a 
 * @param {{created:string}} b 
 */
export function sortPassesByCreated(a, b) {
  const a_date = Date.parse(a.created);
  const b_date = Date.parse(b.created);
  return a_date > b_date;
}
/**
 * 
 * @param {number} selectedPassId 
 * @returns {function({pass_id:string})}
 */
export function isSelectedPass(selectedPassId) {
  return function ({ pass_id }) {
    return pass_id === (selectedPassId) || selectedPassId === null
  }
}
/**
 * Using moment's 'fromNow' function,
 * returns the plain english difference
 * from the 'timestamp' until now.
 * NOTE: timestamp must be ISO
 * @param {string} isoTimestamp 
 */
export function asTimeDiff(isoTimestamp) {
  const diff = _(isoTimestamp, "YYYY-MM-DDTHH:mm:ss.sssZ").fromNow();
  return diff;
}
export function iconFromStatus(status) {
  switch (status) {
    case PASS_STATUS.CREATED:
      return "hourglass_empty"
    case PASS_STATUS.REGISTERED:
      return "assignment_turned_in"
    case PASS_STATUS.REDEEMED:
      return "done"
    default:
      return "hourglass_empty"
  }
}
/**
 * @param {{created:string,description:string,guest_name:string,link:string,pass_id:string,pin:string,status:string,timestamp:string,user_id:string} event
 * @returns {{guest_name:string,pass_id:string,status:string,created:string,link?string,pin?:string}}
 */
function historyEventAsPass(event) {
  const { guest_name, pass_id, status, created } = event;
  const pass = { guest_name, pass_id, status, created };
  if (!!event.link) { pass.link = event.link };
  if (!!event.pin) { pass.pin = event.pin };
  return pass;
}
/**
 * THIS NEEDS TO HAPPEN ON THE BACKEND
 * @param {{created:string,description:string,guest_name:string,link:string,pass_id:string,pin:string,status:string,timestamp:string,user_id:string}[]} history 
 * @returns {{guest_name:string,pass_id:string,status:string,created:string,link?:string,pin?:string}}
 */
export function getPassesFromHistory(history) {
  if (history.length === 0) return [];
  const latestPassEvents = {}
  sortLowToHighByAttribute(history, 'timestamp').reverse().forEach((event) => {
    if (!latestPassEvents[event.pass_id]) {
      latestPassEvents[event.pass_id] = event;
    }
  });
  const passes = Object.keys(latestPassEvents).map(e => {
    return latestPassEvents[e]
  }).map(historyEventAsPass);
  return passes.sort(sortPassesByCreated);
}
export function asFullLink(link) {
  return `${window.location.host}${link}`
}
export function getGuestIdFromRouter(router) {
  if (router.location.pathname.match(GUEST_REGEX)) {
    return router.location.pathname.match(GUEST_REGEX)[1];
  } else {
    return null;
  }
}


// WEBPACK FOOTER //
// ./src/util/selectors.js